import {
  BuyingGuide64,
  FindaDealer64,
  CarValuationTool64,
  SellMyCar64,
  VehicleHistoryCheck64,
  Blog64,
  ElectricCars64,
  CarsFromDealerships64,
} from '../../../components/Toolkit/Base64/Sections';
interface Map {
  [name: string]: JSX.Element;
}

const GoFurtherIcons: Map = {
  'find-a-dealer': <FindaDealer64 alt="Find a dealer" />,
  'sell-my-car': <CarsFromDealerships64 alt="Sell My Car" />,
  'instant-offer': <SellMyCar64 alt="Get an Instant Offer" />,
  'value-my-car': <CarValuationTool64 alt="Value My car" />,
  'buying-guide': <BuyingGuide64 alt="Buying Guide" />,
  'greenlight-history-check': <VehicleHistoryCheck64 alt="Car History Check" />,
  'electric-cars': <ElectricCars64 alt="Electric Car Hub" />,
  blog: <Blog64 alt="" />,
};

export default GoFurtherIcons;
